import { Box } from 'dash-ui';
import styled from 'styled-components';

export const SubscriptionProductsContainer = styled(Box)`
  min-width: 384px;

  @media ${({ theme }) => theme.devices.tablet} {
    min-width: 354px;
  }

  @media ${({ theme }) => theme.devices.mobile} {
    min-width: auto;
    width: inherit;
    margin-right: 0px;
  }
`;
